<template>
  <AppAlert variant="warning">
    <strong>Account is suspended:</strong> {{ data.note }}
  </AppAlert>
</template>

<script setup>
import { AppAlert } from '@/components/ui'

defineProps({
  data: { type: Object, required: true }
})
</script>
